module.exports = __webpack_public_path__ + "static/media/tableText2.e2e817a6.png";